"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var table_item_1 = require("./table-item");
var table_header_1 = require("./table-header");
var table_row_1 = require("./table-row");
var table_cell_1 = require("./table-cell");
var prosemirror_tables_1 = require("prosemirror-tables");
exports.isInTable = prosemirror_tables_1.isInTable;
var table_helper_1 = require("./table-helper");
var menu_button_1 = require("./component/menu-button");
var const_1 = require("./const");
var merge = require("lodash.merge");
require("./style.css");
var DEFAULT_PROPS = {
    columnResize: { handleWidth: 5, cellMinWidth: 56 },
    table: const_1.TABLE_CONFIG,
    button: menu_button_1.BUTTON_DEFAULT_CONFIG
};
// locale menuTip 菜单的提示
var TablePlugin = /** @class */ (function (_super) {
    __extends(TablePlugin, _super);
    function TablePlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TablePlugin.prototype.init = function (editor, props) {
        var config = merge({}, DEFAULT_PROPS, props);
        var sylPlugins = [
            { plugin: table_cell_1.createTableCellPlugin(config.table) },
            { plugin: table_row_1.createTableRowPlugin(config.table) },
            { plugin: table_item_1.TableItemPlugin, controllerProps: __assign(__assign({}, config.table), config.button) }
        ];
        if (config.table.useTableHeader)
            sylPlugins.push({ plugin: table_header_1.createTableHeaderPlugin(config.table) });
        return {
            nativePlugins: [prosemirror_tables_1.columnResizing(config.columnResize), prosemirror_tables_1.tableEditing(config.table), table_helper_1.TableHelperPlugin(editor)],
            sylPlugins: sylPlugins
        };
    };
    return TablePlugin;
}(core_utilities_1.SylUnionPlugin));
exports.TablePlugin = TablePlugin;
//# sourceMappingURL=index.js.map